import { render, staticRenderFns } from "./LottoLogo.vue?vue&type=template&id=04c3f9c5&scoped=true&"
import script from "./LottoLogo.vue?vue&type=script&lang=js&"
export * from "./LottoLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c3f9c5",
  null
  
)

export default component.exports